import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api.base.service';
import { environment } from '@env/environment.local';
import { Observable } from 'rxjs';
import { queryParamsFinancialSetup } from './model.models';

@Injectable({
  providedIn: 'root',
})
export class FinancialSetupService {
  constructor(public api: ApiService) {}

  private basePath: string = 'financial-setup';

  getFinancialSetup(data: queryParamsFinancialSetup): Observable<any> {
    // Listado de paquetes
    return this.api.post(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/all`,
      data
    );
  }

  deleteSetup(idSetup: string | null) {
    return this.api.delete(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${idSetup}`,
      false
    );
  }

  createFinancialSetup(data: any): Observable<any> {
    data.financialSetupName = data.financialSetupName.trim()
    return this.api.post(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}`,
      data
    );
  }

  updateFinancialSetup(id: number, data: any): Observable<any> {
    return this.api.put(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${id}`,
      data
    );
  }

  duplicateFinancialSetup(id: number): Observable<any> {
    return this.api.post(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${id}`,
      {}
    );
  }

  getFinancialSetupById(idSetup: string | null): Observable<any> {
    return this.api.get(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${idSetup}`
    );
  }

  rejectFinancialSetup(
    idSetup: string | null,
    motive: string
  ): Observable<any> {
    return this.api.put(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${idSetup}/reject`,
      { comments: motive }
    );
  }

  approveFinancialSetup(idSetup: string | null): Observable<any> {
    return this.api.put(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${idSetup}/approve`,
      {}
    );
  }

  requestApproveFinancialSetup(idSetup: string | null): Observable<any> {
    return this.api.put(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${idSetup}/request-approve`,
      {}
    );
  }

  createNewVersion(id: number | null): Observable<any> {
    return this.api.post(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${id}/new-version`,
      {}
    );
  }

  getFinancialSetupFilterStatus(id: number) {
    return this.api.get(
      `${environment.API_QUOTE_SERVICE}/${this.basePath}/${id}/filter/status`
    )
  }

}
